import { accountService } from "../_services/accounts.service";

/** Use with useNavigate so admin links work from any current path (e.g. not `/Forms/OfficialLicenseGrades`). */
export function toAppAbsolutePath(url: string): string {
    if (!url) return "/";
    return url.startsWith("/") ? url : `/${url}`;
}

export interface IPrimaryNavInterface {
    icon: string;
    name: string;
    mobileName?: string;
    url: string;
    onClick?: any;
    png?: string;
}

const PRIMARY_ORGANISER_NAV: IPrimaryNavInterface[] = [
    { icon: 'people', name: 'Users', mobileName: 'Users', url: 'Users' },
];

const PRIMARY_ADMIN_NAV: IPrimaryNavInterface[] = [
    { icon: 'request_page', name: 'Forms', mobileName: 'Forms', url: 'Forms' },
    { icon: 'people', name: 'Users', mobileName: 'Users', url: 'Users' },
    { icon: 'receipt_long', name: 'User Transactions', mobileName: 'UserTransactions', url: '/UserTransactions' },
];

const ADMIN_NAV: IPrimaryNavInterface[] = [

    { icon: 'drive_folder_upload', name: 'File Upload Types', mobileName: 'File Upload Types', url: 'FileUploadTypes' },
    { icon: 'class', name: 'Motorsport Licence Types', mobileName: 'Motorsport Licence Types', url: 'RacingLicenseTypes' },
    { icon: 'style', name: 'Motorsport Licences', mobileName: 'Motorsport Licences', url: 'RacingLicenseGrades' },
    { icon: 'class', name: 'Official Licence Types', mobileName: 'Official Licence Types', url: 'OfficialLicenseTypes' },
    { icon: 'style', name: 'Official Licences', mobileName: 'Official Licences', url: 'OfficialLicenseGrades' },
    { icon: 'people', name: 'Accounts', mobileName: 'Accounts', url: 'Accounts' },
    { icon: 'article', name: 'Form Templates', mobileName: 'Form Templates', url: 'FormTemplates' },
    { icon: 'event', name: 'Events', mobileName: 'Events', url: 'Events' },
    { icon: 'summarize_icon', name: 'Reports', mobileName: 'Reports', url: 'Reports' },
    { icon: 'summarize_icon', name: 'Document Template', mobileName: 'Document Template', url: 'EventDocumentTemplate' },
    { icon: 'summarize_icon', name: 'Racing Club', mobileName: 'Racing Club', url: 'RacingClubs' },
    { icon: 'percent', name: 'Discounts', mobileName: 'Discounts', url: 'Discounts' },
    { icon: 'email', name: 'Email Templates', mobileName: 'Email Templates', url: 'EmailTemplates' },
    { icon: 'check_box', name: 'Email Checklist', mobileName: 'Email Checklist', url: 'EmailChecklist' },
    { icon: 'credit_score', name: 'User Credits', mobileName: 'User Credits', url: 'UserCredits' },
];

const CUSTOMER_NAV: IPrimaryNavInterface[] = [
    { icon: 'app_registration', name: 'Register', mobileName: 'Register', url: 'Register' },
];

const USER_NAV: IPrimaryNavInterface[] = [
    { icon: 'logout', name: 'Log Out', url: 'logout', onClick: accountService.logout },
];



export {
    USER_NAV, PRIMARY_ADMIN_NAV, PRIMARY_ORGANISER_NAV, ADMIN_NAV, CUSTOMER_NAV
};

